import React from 'react'
import yellowBalloon from '../yellowBalloon.png'
import redBalloon from '../redBalloon.png'
import styles from '../PartySidePanels.module.css'

function PartySidePanels() {
    return (
        <div id="partySidePanels">
            <div id={styles.leftPanel} className={styles.panel}>
                <img alt="Yellow balloon" src={yellowBalloon} className={styles.balloon+" balloon"}></img>
            </div>
            <div id={styles.rightPanel} className={styles.panel}>
                <img alt="Red balloon" src={redBalloon} className={styles.balloon+" balloon"}></img>
            </div>
        </div>
    )
}

export default PartySidePanels